import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import InputField from "./Fields/InputField";
import MultiField from "./Fields/MultiField";
import SimpleField from "./Fields/SimpleField";
import SpeciesList from "./Fields/DrawFields/SpeciesList";

export default class DrawInput extends AbstractProvidedClass {
    inputs = [];

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv()
            .parent(tabContainer)
            .class('pad-b');

        this.createTitle();
        this.createSpeciesList();
        this.createDimensions();
    }

    setDrawMode(type) {
        this.inputs.map((input) => input.setDrawMode(type));
        type = type == 'polygon' ? 'free shape' : type;
        this.title.value('Draw ' + type);
    }

    setSpecies(speciesId) {
        if (speciesId) {
            this.speciesList.setSpecies(speciesId);
        }
    }

    registerInput(input) {
        input.parent(this.container)
        this.inputs.push(input);
        input.hide();
    }

    createTitle() {
        this.title = SimpleField.setup(this.provider)
            .setType('h3')
            .style('margin-top', '0px')
            .parent(this.container)
            .make();
    }

    createSpeciesList() {
        this.speciesList = SpeciesList.setup(this.provider)
            .make();
        this.registerInput(this.speciesList);
    }

    createDimensions() {
        this.dimensions = SimpleField.setup(this.provider)
            .setType('h3')
            .setStaticValue('Dimensions')
            .class('input-label')
            .make();
        this.registerInput(this.dimensions);

        this.createSize();
        this.createWidth();
        this.createHeight();
        this.createMultiInput();
    }

    createSize() {
        this.size = InputField.setup(this.provider)
            .dimension()
            .id('draw-size')
            .label('Size')
            .attribute('size')
            .style('margin-top', '5px')
            .types(['ellipse'])
            .drawInput()
            .make();
        this.registerInput(this.size);
    }

    createWidth() {
        this.width = InputField.setup(this.provider)
            .dimension()
            .id('draw-width')
            .label('Width')
            .attribute('width')
            .types(['rectangle'])
            .drawInput()
            .make();
        this.registerInput(this.width);
    }

    createHeight() {
        this.height = InputField.setup(this.provider)
            .dimension()
            .id('draw-height')
            .label('Height')
            .attribute('height')
            .types(['rectangle'])
            .drawInput()
            .make();
        this.registerInput(this.height);
    }

    createMultiInput() {
        this.multiInput = MultiField.setup(this.provider)
            .class('input-group')
            .types(['polygon', 'line'])
            .drawInput()
            .make();
        this.registerInput(this.multiInput);
    }

    hide() {
        this.container.hide();
    }

    show() {
        this.container.show();
    }

    reset() {
        this.inputs.map((input) => input.reset());
    }
}
